/* eslint-disable no-prototype-builtins */
import React, { useState, useEffect } from 'react'
import { useNavigate, useParams, Link } from 'react-router-dom'
import axios from 'axios'
import ReactHtmlParser from 'react-html-parser'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied'
import SentimentNeutralIcon from '@mui/icons-material/SentimentNeutral'
import SentimentSatisfiedIcon from '@mui/icons-material/SentimentSatisfied'
import SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAlt'
import ThumbDownIcon from '@mui/icons-material/ThumbDown'
import ThumbUpIcon from '@mui/icons-material/ThumbUp'
import FavoriteIcon from '@mui/icons-material/Favorite'

import { scorecardPointsObj, hingeProfileItemBorderWidth, hingeProfileItemBorderRadius, hingeProfileItemBorderColor, hingeProfileItemBoxShadow, bumbleProfileItemBorderWidth, bumbleProfileItemBorderRadius, bumbleProfileItemBorderColor, bumbleProfileItemBoxShadow, tinderProfileItemBorderWidth, tinderProfileItemBorderRadius, tinderProfileItemBorderColor, tinderProfileItemBoxShadow } from '../../../helpers/variableDefaults'

export const viewFeedbackAndVerdictForItemJSX = (feedbackAndVerdictObj, itemType, profileType = 'hinge') => {
  return (
    <Box
      sx={{
        px: 2, py: 2,
        backgroundColor: feedbackAndVerdictObj.verdict === 'No' ? 'mistyrose' : feedbackAndVerdictObj.verdict === 'Somewhat' ? 'linen' : feedbackAndVerdictObj.verdict === 'Yes' ? 'lightblue' : 'lightblue',
        width: '100%',
        border: profileType === 'bumble' ? bumbleProfileItemBorderWidth : profileType === 'tinder' ? tinderProfileItemBorderWidth : profileType === 'hinge' ? hingeProfileItemBorderWidth : hingeProfileItemBorderWidth,
        borderColor: profileType === 'bumble' ? bumbleProfileItemBorderColor : profileType === 'tinder' ? tinderProfileItemBorderColor : profileType === 'hinge' ? hingeProfileItemBorderColor : hingeProfileItemBorderColor,
        boxShadow: profileType === 'bumble' ? bumbleProfileItemBoxShadow : profileType === 'tinder' ? tinderProfileItemBoxShadow : profileType === 'hinge' ? hingeProfileItemBoxShadow : hingeProfileItemBoxShadow, 
        borderRadius: profileType === 'bumble' ? `0px 0px 0px 0px` : profileType === 'tinder' ? `0px 0px ${tinderProfileItemBorderRadius} ${tinderProfileItemBorderRadius}` : profileType === 'hinge' ? `0px 0px ${hingeProfileItemBorderRadius} ${hingeProfileItemBorderRadius}` : `0px 0px 0px 0px`,
        display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',
      }}
    >
      {/* Feedback */}
      {feedbackAndVerdictObj.feedback.length > 0 && feedbackAndVerdictObj.feedback !== 'No Written Feedback' &&
        <Typography
          textAlign={'left'}
          sx={{
            width: '100%',
            // color: 'white',
          }}
        >
          <span style={{ fontWeight: 'bold' }}>Feedback: </span><span style={{ fontStyle: 'italic' }}>{feedbackAndVerdictObj.feedback}</span>
        </Typography>
      }

      {/* Verdict */}
      <Box
        sx={{
          mt: 1,
          width: '100%',
          display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center',
        }}
      >
        {/* Verdict */}
        <Box
          sx={{
            // width: '100%',
            display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'flex-start',
          }}
        >
          <Typography
            sx={{
              // color: 'white',
              fontWeight: 'bold',
            }}
          >
            Verdict:
          </Typography>
          <Box
            sx={{
              ml: 2,
              width: '30px',
              height: '30px',
            }}
          >
            {feedbackAndVerdictObj.verdict === 'No'
              ?
              <ThumbDownIcon 
                sx={{
                  color: 'red',
                }}
              />
              :
              feedbackAndVerdictObj.verdict === 'Somewhat'
                ?
                <SentimentNeutralIcon 
                  sx={{
                    color: 'black',
                  }}
                />
                :
                feedbackAndVerdictObj.verdict === 'Yes'
                  ?
                  <ThumbUpIcon 
                    sx={{
                      color: 'blue',
                    }}
                  />
                  :
                  <FavoriteIcon 
                    sx={{
                      color: 'green',
                    }}
                  />
            }
          </Box>

        </Box>

        {/* Points */}
        {(feedbackAndVerdictObj.verdict === 'Very' || feedbackAndVerdictObj.verdict === 'Yes' || feedbackAndVerdictObj.verdict === 'Somewhat' || feedbackAndVerdictObj.verdict === 'No')
          &&
          <Box
            sx={{
              fontWeight: 900,
            }}
          >
            {`${scorecardPointsObj[itemType][feedbackAndVerdictObj.verdict.toLowerCase()] > 0 ? '+' : ''}${scorecardPointsObj[itemType][feedbackAndVerdictObj.verdict.toLowerCase()]}`}
          </Box>
        }
      </Box>

    </Box>
  )
}